import Check from "../../../../../components/atoms/icons/check";
import CheckIndeterminate from "../../../../../components/atoms/icons/check-indeterminate";
import { cn } from "../../../../../utils/cn";
import { cva } from "class-variance-authority";

const variants = {
  check:
    "text-semantic-primary-background-normal-default hover:text-semantic-primary-background-normal-hovered group-hover:text-semantic-primary-background-normal-hovered disabled:text-semantic-primary-background-normal-default disabled:hover:text-semantic-primary-background-normal-default",
  checkbox: [
    "text-semantic-static-global-global-white",
    "bg-semantic-primary-background-normal-default",
    "hover:bg-semantic-primary-background-normal-hovered",
    "active:bg-semantic-primary-background-normal-pressed",
    "group-hover:bg-semantic-primary-background-normal-hovered",
    "group-active:bg-semantic-primary-background-normal-pressed",
    "disabled:bg-semantic-primary-background-normal-default",
    "disabled:hover:bg-semantic-primary-background-normal-default",
    "disabled:active:bg-semantic-primary-background-normal-default",
  ].join(" "),
  indeterminate: [
    "text-semantic-static-global-global-white",
    "bg-semantic-primary-background-normal-default",
    "hover:bg-semantic-primary-background-normal-hovered",
    "active:bg-semantic-primary-background-normal-pressed",
  ].join(" "),
};

const checkboxVariants = cva(
  "size-8 flex items-center justify-center rounded-[2px]",
  {
    variants: {
      variant: variants,
      disabled: {
        true: "opacity-50 cursor-not-allowed transition-opacity",
        false: "",
      },
    },
    defaultVariants: {
      variant: "checkbox",
      disabled: false,
    },
  }
);

// export interface CheckboxProps extends VariantProps<typeof checkboxVariants> {
//   id: string;
//   checked?: boolean;
//   className?: string;
//   onChange?: (checked: boolean) => void;
//   disabled?: boolean;
// }

export const Checkbox = ({
  id,
  checked = false,
  variant,
  className,
  onChange,
  disabled = false,
}) => {
  const handleClick = (e) => {
    if (!disabled) {
      onChange?.(!checked);
    }
    e.stopPropagation();
  };

  const renderCheckboxContent = () => {
    const commonStyles = cn(
      "size-8",
      checkboxVariants({ variant, disabled, className })
    );

    if (variant === "checkbox") {
      return checked ? (
        <div className={commonStyles}>
          <Check size={20} className="-m-2" />
        </div>
      ) : (
        <div
          className={cn(
            "size-8 border-2 rounded-[2px] border-semantic-secondary-foreground-inverse-default",
            disabled && "opacity-50"
          )}
        />
      );
    }

    if (checked) {
      return (
        <div className={commonStyles}>
          <Check size={20} className="-m-2" />
        </div>
      );
    }

    if (variant === "indeterminate") {
      return (
        <div className={cn(commonStyles)}>
          <CheckIndeterminate size={20} className="-m-2" />
        </div>
      );
    }

    return <div className={cn("size-8", disabled && "opacity-50")} />;
  };

  return (
    <>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={(e) => !disabled && onChange?.(e.target.checked)}
        disabled={disabled}
        className="sr-only"
        aria-label={`checkbox-${id}`}
        ref={(el) => {
          if (el) {
            el.indeterminate = variant === "indeterminate";
          }
        }}
      />
      <div onClick={handleClick} className={cn("inline-block")}>
        {renderCheckboxContent()}
      </div>
    </>
  );
};

Checkbox.displayName = "Checkbox";
